import { Chip as WDSChip, ChipProps as WDSChipProps } from "@datamole/wds-component-chip";
import { forwardRef } from "react";

type Props = {
    startIcon?: React.ReactNode;
} & WDSChipProps;

const Chip = forwardRef<HTMLSpanElement, Props>((props, ref) => {
    const { children, startIcon, ...otherProps } = props;

    return (
        <WDSChip ref={ref} {...otherProps}>
            {startIcon && <WDSChip.Icon>{startIcon}</WDSChip.Icon>}
            <WDSChip.Content>{children}</WDSChip.Content>
        </WDSChip>
    );
});

Chip.displayName = "Chip";

export { Chip };
export type { Props as ChipProps };
